// UnitsSettingsViewModel.ts
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { UnitModel } from "../../model/UnitsModel";
import {
  readUnitsRequest,
  updateUnitRequest,
  deleteUnitRequest,
  addUnitRequest,
} from "../../services/APIService";

export const useUnitsSettingsVM = (loggedID: string) => {
  const navigate = useNavigate();
  const [emCars, setEmCars] = useState<UnitModel[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const loadUnits = useCallback(async () => {
    if (!loggedID) return;
    try {
      const data = await readUnitsRequest(loggedID);
      if (Array.isArray(data)) {
        setEmCars(data);
      }
    } catch (error) {
      console.error("Fehler beim Lesen der Einheiten:", error);
    }
  }, [loggedID]);

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  const updateLocalName = (id: number, field: string, value: string) => {
    setEmCars((prevCars) =>
      prevCars.map((car) =>
        car.ID === id ? { ...car, [field]: value } : car
      )
    );
  };

  const handleNameChange = async (unitID: string, value: string) => {
    try {
      const data = await updateUnitRequest(unitID, "Unit", value);
      if (data.status === "success") {
        await loadUnits();
      } else {
        alert("Einheit konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error("Fehler beim Aktualisieren der Einheit:", error);
    }
  };

  const deleteCar = async (id: number) => {
    try {
      const data = await deleteUnitRequest(id);
      if (data.status === "success") {
        await loadUnits();
      } else {
        alert("Einheit konnte nicht gelöscht werden");
      }
    } catch (error) {
      console.error("Fehler beim Löschen der Einheit:", error);
    }
  };

  const addCar = async () => {
    try {
      const data = await addUnitRequest(loggedID);
      if (data.status === "success") {
        await loadUnits();
      } else {
        alert("Einheit konnte nicht angelegt werden");
      }
    } catch (error) {
      console.error("Fehler beim Anlegen der Einheit:", error);
    }
  };

  const onBackClick = () => navigate("/MainPage"); // <-- Hier hinzugefügt

  const filteredCars = emCars.filter((car) =>
    car.Unit.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return {
    state: {
      emCars,
      searchTerm,
      filteredCars,
    },
    actions: {
      setSearchTerm,
      updateLocalName,
      handleNameChange,
      deleteCar,
      addCar,
      onBackClick, // <-- Hier zurückgegeben
    },
  };
};